<form class="secondary-industry-selection-component" [formGroup]="formGroup">
  <mat-form-field>
    <mat-label>Industry sector</mat-label>
    <mat-select [formControl]="formControl" placeholder="Select sector..." [compareWith]="compareWithFn">
      @for (secondaryIndustry of secondaryIndustries; track secondaryIndustry) {
        <mat-option [value]="secondaryIndustry">
          {{secondaryIndustry.title}}
        </mat-option>
      }
    </mat-select>
    @for (errorKey of errorKeys(formControl); track errorKey) {
      <mat-error>
        @if (formControl.touched && formControl.hasError(errorKey)) {
          {{errorMessage(formControl, errorKey)}}
        }
      </mat-error>
    }
  </mat-form-field>
</form>
